// Subpath entry for the auth API schemas: `@galapagos/shared/api/auth`.
// Pure Zod (no AWS SDK), so it is mobile-bundle-safe — but kept on a subpath
// to mirror the db/auth subpath convention and keep the top barrel lean.
export * from '../src/api/auth';
